import { Helmet } from "react-helmet";
import React, { useState } from "react";
import Header from "../components/Header/Header";
import HomeContainer from "../containers/HomeContainer";
import FullHeight from "../components/FullHeight/FullHeight";
import MainCanvas from "../components/three/MainCanvas";
import Footer from "../components/Footer/Footer";

const Home = () => {
  // dark theme
  document.body.classList.add("dark");
  const TITLE = "quanle.is";
  const [isActive, setActive] = useState(false);

  const activeHome = (e) => {
    e.preventDefault();
    setActive(!isActive);

    const buttonEnter = document.querySelector(".enter-btn");
    const mainWrapper = document.querySelector(".main");

    buttonEnter.classList.add("disabled");
    mainWrapper.classList.add("active");
  };

  return (
    <>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>
      <Header isActive={isActive} logoSource="/images/logo-q-circle.svg" />
      <FullHeight isActive={isActive} />
      <MainCanvas isActive={isActive} />
      <div className="main">
        <div className="enter-btn">
          <button
            className="animate__animated animate__fadeIn"
            id="enterbtn"
            onClick={activeHome}
          >
            ENTER
          </button>
        </div>
        <HomeContainer isActive={isActive} />
        <Footer isActive={isActive} />
      </div>
    </>
  );
};

export default Home;
